import { render, staticRenderFns } from "./pos-ZeroInventory.vue?vue&type=template&id=d65bcbe6&"
import script from "./pos-ZeroInventory.vue?vue&type=script&lang=js&"
export * from "./pos-ZeroInventory.vue?vue&type=script&lang=js&"
import style0 from "./pos-ZeroInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
